import { render, staticRenderFns } from "./LandingWarren.vue?vue&type=template&id=5b589f56&scoped=true&class=white&"
import script from "./LandingWarren.vue?vue&type=script&lang=ts&"
export * from "./LandingWarren.vue?vue&type=script&lang=ts&"
import style0 from "./LandingWarren.vue?vue&type=style&index=0&id=5b589f56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b589f56",
  null
  
)

export default component.exports